import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import About from "./About";
import Contact from "./Contact";
import Hero from "./Hero";
import Nav from "./Nav";
// import ProjectsPreview from "./ProjectsPreview";
import TravelTeaser from "./TravelTeaser";
import Work from "./Work";
import Writing from "./Writing";
import { NAV_H, SPY_IDS } from "./Nav";

const Landing = () => {
  const [activeSection, setActiveSection] = useState("about");
  const location = useLocation();

  // Scroll-spy: update active nav link as user scrolls
  useEffect(() => {
    let raf = 0;
    const onScroll = () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = 0;
        const probe = NAV_H + 120;
        let current = "about";
        for (const id of SPY_IDS) {
          const el = document.getElementById(id);
          if (el && el.getBoundingClientRect().top <= probe) current = id;
        }
        setActiveSection(current);
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Scroll to hash when navigating from another page (e.g., /#about)
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const timer = setTimeout(() => {
        const el = document.getElementById(id);
        if (!el) return;
        const y = window.scrollY + el.getBoundingClientRect().top - NAV_H + 1;
        window.scrollTo({ top: y, behavior: "smooth" });
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [location.hash]);

  return (
    <>
      <Nav activeSectionId={activeSection} />
      <main>
        <Hero />
        <About />
        <Work />
        {/* Side Quests hidden for now */}
        {/* <ProjectsPreview /> */}
        <TravelTeaser />
        <Writing />
        <Contact />
      </main>
    </>
  );
};

export default Landing;
